import toJS from 'components/common/toJS';
import MiniWidget from 'components/dashboard/common/MiniWidget';
import useSettingsChangeActionDispatcher from 'components/dashboard/location/useSettingsChangeActionDispatcher';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { getUserTimezone } from 'reducers/auth';
import { actions, getReport, getRequestDate, isReportFetching } from 'reducers/dashboard/location/firstTimeMini';
import { getReport as getTotalCustomersReport } from '../../../reducers/dashboard/location/totalCustomersMini';
import { percentageOfTotal } from '../common/utils';

function FirstTimeMiniWidget({
  location,
  history,
  isFetching,
  requestDate,
  userTimezone,
  report,
  reportRequest,
  defaultLocationId,
  totalCustomersReport,
}) {
  useSettingsChangeActionDispatcher(location, history, userTimezone, reportRequest, defaultLocationId);

  if (!requestDate) {
    return null;
  }

  const total = totalCustomersReport?.rows?.[0]?.row?.eventsCount;
  const value = report?.rows?.[0]?.row?.newCustomers;
  return (
    <MiniWidget
      isFetching={isFetching}
      title="First time"
      value={value}
      rightHelperText={percentageOfTotal(value, total)}
    />
  );
}

function mapStateToProps(state) {
  return {
    isFetching: isReportFetching(state),
    requestDate: getRequestDate(state),
    report: getReport(state),
    totalCustomersReport: getTotalCustomersReport(state),
    userTimezone: getUserTimezone(state),
  };
}

export default withRouter(
  connect(mapStateToProps, { reportRequest: actions.reportRequest })(toJS(FirstTimeMiniWidget))
);
